import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { TenantInfo } from 'src/app/shared/models/tenant-info';
import { UserInfo } from 'src/app/shared/models/user-info';
import { map, switchMap, tap } from 'rxjs/operators';
import { GlobalConfig } from 'src/app/shared/models/global';
import { Code } from 'src/app/shared/models/code';
import { Classeur } from 'src/app/shared/models/classeur';
import { Chemise, ChemiseCreate } from 'src/app/shared/models/chemise';
import { Service } from 'src/app/shared/models/service';
import { Roles } from 'src/app/shared/models/roles';
import { Langues } from 'src/app/shared/models/global/langues';
import { MeUserInfo } from 'src/app/shared/models/me/user-info';
import { ClassementDossiers } from 'src/app/shared/models/global/classement-dossiers';
import { MeRightsManagementAdmin } from 'src/app/shared/models/admin/rights-management-admin';
import {
  ClassementAdmin,
  CreateClassementAdmin,
  FolderClassificationDto,
  SearchFoldersClassificationParams,
} from 'src/app/shared/models/admin/classement';
import { CreateFolderAdmin, Folder } from 'src/app/shared/models/admin/folder';

@Injectable({
  providedIn: 'root',
})
export class iAdminService {
  public apiBaseUrl: string;
  public body: FormData;
  public headers: any;
  public params: HttpParams = new HttpParams();
  private globalConfigSubject$ = new BehaviorSubject<GlobalConfig>(null);
  private managmentUser$ = new BehaviorSubject<any>(null);

  constructor(public http: HttpClient) {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    this.apiBaseUrl = config.apiIAdminBaseUrl + '/api/v1';
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    this.body = new FormData();
    this.params = new HttpParams();
  }

  getGlobalConfig(): Observable<GlobalConfig> {
    if (!this.globalConfigSubject$.value) {
      this.http.get<GlobalConfig>(`${this.apiBaseUrl}/Global/Configuration`).subscribe((res) => {
        this.globalConfigSubject$.next(res);
      });
    }
    return this.globalConfigSubject$.asObservable();
  }

  managmentUsers(id: number): Observable<any> {
    return of(this.managmentUser$.value).pipe(
      switchMap((user) => {
        if (!user) {
          return this.http
            .get<any>(`${this.apiBaseUrl}/Management/Users/${id}`)
            .pipe(tap((res) => this.managmentUser$.next(res)));
        } else {
          return this.managmentUser$.asObservable();
        }
      })
    );
  }

  public fetchMyOwnServices(): Observable<Service[]> {
    return this.http.get<Service[]>(`${this.apiBaseUrl}/Me/Services`);
  }

  getRightsManagement(): Observable<MeRightsManagementAdmin> {
    return this.http.get<MeRightsManagementAdmin>(`${this.apiBaseUrl}/Me/Rights/Management`);
  }

  //* Gets the infos about the tenant the user's connected in
  getTenant(): Observable<TenantInfo> {
    return this.http.get<TenantInfo>(`${this.apiBaseUrl}/Global/TenantInfo`).pipe(
      map((res) => {
        return new TenantInfo(res);
      })
    );
  }

  //! cette fonction fonctionne en localhost mais ne fonctionne pas en dev => Soucis asynchrone, j'ai du revenir à la fonction d'avant
  // getUserInfo(): Observable<UserInfo> {
  //   return this.userInfoSubject$.pipe(
  //     switchMap((userInfo) => {
  //       if (!userInfo) {
  //         return this.http.get<UserInfo>(`${this.apiBaseUrl}/Me/UserInfo`).pipe(
  //           tap((res) => this.userInfoSubject$.next(res))
  //         );
  //       } else {
  //         return this.userInfoSubject$.asObservable();
  //       }
  //     })
  //   );
  // }

  getUserInfo(): Observable<UserInfo> {
    return this.http.get<UserInfo>(`${this.apiBaseUrl}/Me/UserInfo`);
  }

  // Global
  getGlobalLangues(): Observable<Langues[]> {
    return this.http.get<Langues[]>(`${this.apiBaseUrl}/Global/Langues`);
  }
  getGlobalServices(): Observable<Service[]> {
    return this.http.get<Service[]>(`${this.apiBaseUrl}/Global/Services`);
  }
  getUsersByServiceId(id): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Global/Services/${id}/Users/ids`);
  }
  getGlobalClassementById(id: number): Observable<ClassementDossiers> {
    return this.http.get<ClassementDossiers>(`${this.apiBaseUrl}/Global/ClassementDossiers/${id}`);
  }

  public fetchFoldersClassification(
    searchFoldersClassificationParams?: SearchFoldersClassificationParams
  ): Observable<FolderClassificationDto[]> {
    return this.http.get<FolderClassificationDto[]>(`${this.apiBaseUrl}/Global/ClassementDossiers/Search`, {
      params: searchFoldersClassificationParams ? { ...searchFoldersClassificationParams } : {},
    });
  }

  getGlobalClassementCode(): Observable<Code[]> {
    return this.http.get<Code[]>(`${this.apiBaseUrl}/Global/Classements/Search`);
  }

  getGlobalClasseurs(data?: object): Observable<Classeur[]> {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    return this.http.get<Classeur[]>(`${this.apiBaseUrl}/Global/Classeurs?${params}`);
  }

  getGlobalChemises(data?: object): Observable<Chemise[]> {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    return this.http.get<Chemise[]>(`${this.apiBaseUrl}/Global/Chemises?${params}`);
  }

  postChemises(data: ChemiseCreate): Observable<ChemiseCreate> {
    return this.http.post<ChemiseCreate>(`${this.apiBaseUrl}/Management/Chemises`, data);
  }

  getGlobalRoles(): Observable<Roles[]> {
    return this.http.get<Roles[]>(`${this.apiBaseUrl}/Global/Roles`);
  }

  getFormesJuridiquesAdmin() {
    return this.http.get(`${this.apiBaseUrl}/Global/FormesJuridiques`);
  }

  getContactTitres() {
    return this.http.get(`${this.apiBaseUrl}/Global/contactTitres`);
  }

  getContactTypeAdmin() {
    return this.http.get(`${this.apiBaseUrl}/Global/contactTypes`);
  }

  putContactTypeAdmin(id: number) {
    return this.http.put(`${this.apiBaseUrl}/Global/contactTypes/${id}`, null);
  }

  getContactCategories(id: number) {
    return this.http.get<any>(`${this.apiBaseUrl}/Global/contactCategories/${id}`, this.headers);
  }

  getManagementTypesContacts() {
    return this.http.get<any>(`${this.apiBaseUrl}/Management/TypesContacts`, this.headers);
  }

  postManagementTypesContacts(data) {
    return this.http.post<any>(`${this.apiBaseUrl}/Management/TypesContacts`, data);
  }

  createClassement(data: CreateClassementAdmin): Observable<CreateClassementAdmin> {
    return this.http.post<CreateClassementAdmin>(`${this.apiBaseUrl}/Management/Classements`, data);
  }

  getClassement(): Observable<ClassementAdmin> {
    return this.http.get<ClassementAdmin>(`${this.apiBaseUrl}/Management/Classements`);
  }

  createFolder(data: CreateFolderAdmin): Observable<Folder> {
    return this.http.post<Folder>(`${this.apiBaseUrl}/Management/Fardes`, data);
  }

  // getFolder(): Observable<any> {
  //   return this.http.get<any>(`${this.apiBaseUrl}/Management/Classements`);
  // }
}
